"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedCircleIEFallback = exports.AnimatedCircle = exports.CarIcon = exports.LoaderWrapper = exports.Wrapper = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var overlayBackgroundColor = function overlayBackgroundColor(_a) {
  var isFullScreen = _a.isFullScreen,
      opaqueBackground = _a.opaqueBackground;
  if (!isFullScreen) return 'transparent';
  var opacity = opaqueBackground ? '1' : '0.5';
  return "rgba(255, 255, 255, " + opacity + ")";
};

exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  background-color: ", ";\n  top: ", ";\n  left: ", ";\n  position: ", ";\n  width: ", ";\n  height: ", ";\n  padding-top: ", "px;\n  display: flex;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n"], ["\n  z-index: ", ";\n  background-color: ", ";\n  top: ", ";\n  left: ", ";\n  position: ", ";\n  width: ", ";\n  height: ", ";\n  padding-top: ", "px;\n  display: flex;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.isFullScreen ? '100' : 'inherit';
}, function (props) {
  return overlayBackgroundColor(props);
}, function (props) {
  return props.isFullScreen ? '0' : 'inherit';
}, function (props) {
  return props.isFullScreen ? '0' : 'inherit';
}, function (props) {
  return props.isFullScreen ? 'fixed' : 'inherit';
}, function (props) {
  return props.isFullScreen ? '100vw' : '100%';
}, function (props) {
  return props.isFullScreen ? '100vh' : 'inherit';
}, function (props) {
  return props.hasPaddingTop ? 100 : 0;
});
exports.LoaderWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100px;\n  z-index: 701;\n  opacity: 1;\n  &:before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n  }\n"], ["\n  position: relative;\n  width: 100px;\n  z-index: 701;\n  opacity: 1;\n  &:before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n  }\n"])));
var wink = (0, styled_components_1.keyframes)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"])));
var rotate = (0, styled_components_1.keyframes)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var dash = (0, styled_components_1.keyframes)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n"], ["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n"])));

var color = function color(props) {
  return (0, styled_components_1.keyframes)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  100%,\n  0% {\n    stroke: ", ";\n  }\n  40% {\n    stroke: ", ";\n  }\n  66% {\n    stroke: ", ";\n  }\n  80%,\n  90% {\n    stroke: #f1a426;\n  }\n"], ["\n  100%,\n  0% {\n    stroke: ", ";\n  }\n  40% {\n    stroke: ", ";\n  }\n  66% {\n    stroke: ", ";\n  }\n  80%,\n  90% {\n    stroke: #f1a426;\n  }\n"])), props.theme.color.primary.v400, props.theme.color.primary.v600, props.theme.color.primary.v200);
};

exports.CarIcon = styled_components_1.default.svg(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  color: ", ";\n  fill: ", ";\n  position: absolute;\n  top: ", "%;\n  left: ", "%;\n  animation: ", " 1.25s ease-in-out infinite alternate;\n  z-index: 701;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  color: ", ";\n  fill: ", ";\n  position: absolute;\n  top: ", "%;\n  left: ", "%;\n  animation: ", " 1.25s ease-in-out infinite alternate;\n  z-index: 701;\n"])), function (props) {
  return props.isLarge ? 29 : 22;
}, function (props) {
  return props.isLarge ? 29 : 22;
}, function (props) {
  return props.theme.color.primary.v400;
}, function (props) {
  return props.theme.color.primary.v400;
}, function (props) {
  return props.isLarge ? 35 : 39;
}, function (props) {
  return props.isLarge ? 35 : 39;
}, wink);
exports.AnimatedCircle = styled_components_1.default.svg(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: ", "%;\n  height: ", "%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  animation: ", " 2s linear infinite;\n  z-index: 701;\n  & > circle {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    animation: ", " 1.5s ease-in-out infinite,\n      ", " 6s ease-in-out infinite;\n    stroke-linecap: round;\n  }\n"], ["\n  width: ", "%;\n  height: ", "%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  animation: ", " 2s linear infinite;\n  z-index: 701;\n  & > circle {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    animation: ", " 1.5s ease-in-out infinite,\n      ", " 6s ease-in-out infinite;\n    stroke-linecap: round;\n  }\n"])), function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.isLarge ? 100 : 70;
}, rotate, dash, function (props) {
  return color(props);
});
var ballClipRotate = (0, styled_components_1.keyframes)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
exports.AnimatedCircleIEFallback = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    &:after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      border: 2px solid ", ";\n      border-bottom-color: transparent;\n      border-radius: 50%;\n      background: transparent;\n      animation: ", " 0.75s linear infinite;\n    }\n  }\n"], ["\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    &:after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      display: inline-block;\n      border: 2px solid ", ";\n      border-bottom-color: transparent;\n      border-radius: 50%;\n      background: transparent;\n      animation: ", " 0.75s linear infinite;\n    }\n  }\n"])), function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.theme.color.primary.v200;
}, function (props) {
  return props.theme.color.primary.v200;
}, ballClipRotate);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;